import { AuthService } from '@common-services/util/auth.service';
import { TOKEN_ID } from '@constants/router.const';
import { AppModuleInjector } from '@dice/app.module';
import { Environment } from '@dice/app/types/env.type';
import { RxStomp, RxStompConfig } from '@stomp/rx-stomp';
import { CookieService } from 'ngx-cookie-service';

function socketFactory(environment: Environment): WebSocket {
  return new WebSocket(environment.notifications);
}

export function notificationConfigFactory(environment: Environment, cookieService: CookieService): RxStompConfig {
  const authToken = cookieService.get(TOKEN_ID);
  return {
    webSocketFactory: (): WebSocket => socketFactory(environment),
    connectHeaders: {
      Authorization: authToken,
    },
    heartbeatIncoming: 0,
    heartbeatOutgoing: 0,
    reconnectDelay: 1000,
    debug: (msg: string): void => {
      if (environment.enableDebugInfo) {
        customLogger.log('[NotificationStomp - debug]:', msg);
      }
    },
    beforeConnect: (stomp: RxStomp): void => {
      stomp.stompClient.onStompError = (err): void => {
        if (err.headers.message.includes('401_AUTHORIZATION_EXCEPTION')) {
          stomp.stompClient.deactivate();
          customLogger.error('[Notification StompConfig] - LOGOUT!');
          const authService = AppModuleInjector.get(AuthService);
          authService.logout();
        }
      };
    },
  };
}
